// extracted by mini-css-extract-plugin
export var avatar = "_rf-3";
export var avatarContainer = "_rf-2";
export var avatarSpacer = "_rf-5";
export var avatarSpacerContainer = "_rf-4";
export var avatarStackContainer = "_rf-1";
export var bubble = "_rf-0";
export var remainderBubble = "_rf-6";